import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 24,
	height: 22,
	viewBox: "0 0 24 22",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M18.752 18.579C13.639 19.305 12 21.125 12 21.125V3.712S9.545.985 1.268.875a.506.506 0 0 0-.366.15.522.522 0 0 0-.152.369v16.375c-.002.28.22.51.5.519C9.543 18.4 12 21.125 12 21.125m0-17.413S14.455.985 22.732.875a.506.506 0 0 1 .366.15.52.52 0 0 1 .152.369v12.231",
			stroke: "#262626",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.75 18.564v-4.39a.557.557 0 0 1 .563-.549h3.937l-4.5 4.939Z",
			stroke: "#262626",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			clipRule: "evenodd"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20width%3D%2224%22%20height%3D%2222%22%20viewBox%3D%220%200%2024%2022%22%3E%3Cpath%20d%3D%22M18.752%2018.579C13.639%2019.305%2012%2021.125%2012%2021.125V3.712S9.545.985%201.268.875a.506.506%200%200%200-.366.15.522.522%200%200%200-.152.369v16.375c-.002.28.22.51.5.519C9.543%2018.4%2012%2021.125%2012%2021.125m0-17.413S14.455.985%2022.732.875a.506.506%200%200%201%20.366.15.52.52%200%200%201%20.152.369v12.231%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M18.75%2018.564v-4.39a.557.557%200%200%201%20.563-.549h3.937l-4.5%204.939Z%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E";
